import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ChequePicked from "./chequePicked";
import { getChequePickedList } from "services/redux/brandActivtion/meetings/action";

import {
  getSiteFilters,
} from 'services/redux/brandActivtion/sitesListing/action';

const mapStateToProps = (state) => ({
  chequePickedList: state.baMeetingReducer.chequePickedList
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getChequePickedList
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ChequePicked);
